import { TFactoryState } from '../factory/factory.type';
export type TRESPONSE_Factory_Api = {
  result: TFactoryState['factoryInfo'][];
  // NOTE: Not used anywhere same data is in result array at 0 index
  validatedOIAppMetadata: TFactoryState['factoryInfo'];
};

interface IShiftDTO {
  shift_id: string;
  shift_display_name: string;
}

export type TShiftDtoResponse = IShiftDTO[];

type TNavigationTabsTypes =
  | 'ANALYTICS'
  | 'REPORTS'
  | 'ORDERS_DASHBOARD'
  | 'MM_ANALYTICS'
  | 'REPORTS_V2'
  | 'MM_ANALYTICS_CHATBOT';

export type TLANGUAGE_OPTIONS = {
  languageCode: string;
  languageDisplay: string;
  languageDisplayLocale: string;
};

export type THeaderResponse = {
  language: TLANGUAGE_OPTIONS[];
  navigationTabs: TNavigationTabsTypes[];
  shifts: TShiftDtoResponse;
  isLoading: boolean;
  activeTab: TNavigationTabsTypes;
  isMobileNavVisible: boolean;
};

export type TREQUEST_Factory_Api = {
  query_name: string;
  subject_key: string;
};

export const DISABLE_ERROR_ALERT_HEADER = 'No-Error-Alert';
